import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCXY_i9zeHs6whsUoPXhRvVUpcKScDPc_Y",
  authDomain: "jogunbiz.firebaseapp.com",
  projectId: "jogunbiz",
  storageBucket: "jogunbiz.firebasestorage.app",
  messagingSenderId: "931185843768",
  appId: "1:931185843768:web:9d429ba3f0c61dd443d0cd",
};

const app = initializeApp(firebaseConfig);
export { app as firebaseApp };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
